import React, { useEffect, useState } from 'react'
import 'react-toastify/dist/ReactToastify.css';
import JoinTeams from "./JoinTeams"
import HomePage from "./HomePage"

import {
  HashRouter as Router,
  Switch,
  Route
} from "react-router-dom";

function App() {

  useEffect(() => {

  }, [])

  return (
    <Router>
     <Switch>
        <Route exact path="/">
          <HomePage />
        </Route>
        <Route path="/j/:id" render={props => <JoinTeams {...props.match.params} />} />
      </Switch>
    </Router>
  );

}

export default App;
